import React, { memo } from 'react';
import './demandPlannerYoySec.scss';

const MskuInfoTable = memo((props) => {

    return (
        <table className='msku-info-table' style={{ position: 'sticky', left: 0, zIndex: 1 }}>
            <thead>
                <tr>
                    <th colSpan='5' className='header-bg-1 msku-cell fix-top-0'></th>
                </tr>
                <tr>
                    <th className='header-bg-2 msku-cell fix-top-24'>Brand</th>
                    <th className='header-bg-2 msku-cell fix-top-24'>Format</th>
                    <th className='header-bg-2 msku-cell fix-top-24'>Variant</th>
                    <th className='header-bg-2 msku-cell fix-top-24'>MSKU Code</th>
                    <th className='header-bg-2 msku-cell fix-top-24'>Description</th>
                </tr>
            </thead>
            <tbody>
                {
                    props.data && props.data.Brands.map((brand, index) => (
                        <React.Fragment key={'s'+ index}>
                            {
                                Object.values(brand.MasterSkus.reduce((r, a) => {
                                    r[a.Format] = [...r[a.Format] || [], a];
                                    return r;
                                }, {}))
                                    .map(item => (
                                        item.map((msku, indx) => (
                                            <React.Fragment key={'f' + indx}>
                                                <tr key={'a' + indx} className='row-right-border'>
                                                    <td className='msku-cell msku-cell-bg-white'>
                                                        {brand.BrandName}
                                                    </td>
                                                    <td className='msku-cell msku-cell-bg-white'>
                                                        {msku.Format}
                                                    </td>
                                                    <td className='msku-cell msku-cell-bg-white'>
                                                        {msku.Variant}
                                                    </td>
                                                    <td className='msku-cell msku-cell-bg-white'>
                                                        {msku.MasterSkuCode}
                                                    </td>
                                                    <td className='msku-cell msku-cell-bg-white'>
                                                        {msku.MasterSku}
                                                    </td>
                                                </tr>
                                                {
                                                    item.length - 1 === indx ?
                                                        (
                                                            <tr key={'b' + indx} className='row-right-border'>
                                                                <td className='msku-cell highlight-row-bg-blue'>
                                                                    {brand.BrandName}
                                                                </td>
                                                                <td className='msku-cell highlight-row-bg-blue'>
                                                                    { }
                                                                </td>
                                                                <td className='msku-cell highlight-row-bg-blue'>
                                                                    { }
                                                                </td>
                                                                <td className='msku-cell highlight-row-bg-blue'>
                                                                    { }
                                                                </td>
                                                                <td className='msku-cell highlight-row-bg-blue'>
                                                                    {msku.Format}
                                                                </td>
                                                            </tr>
                                                        )
                                                        :
                                                        null
                                                }
                                            </React.Fragment>
                                        ))
                                    ))
                            }
                            {
                                brand.VariantData.map((variant, varInd) => (
                                    <tr key={'c' + varInd} className='row-right-border'>
                                        <td className='msku-cell highlight-row-bg-green'>
                                            {brand.BrandName}
                                        </td>
                                        <td className='msku-cell highlight-row-bg-green'>
                                            { }
                                        </td>
                                        <td className='msku-cell highlight-row-bg-green'>
                                            { }
                                        </td>
                                        <td className='msku-cell highlight-row-bg-green'>
                                            { }
                                        </td>
                                        <td className='msku-cell highlight-row-bg-green'>
                                            {variant.VariantName}
                                        </td>
                                    </tr>
                                ))
                            }
                            <tr key={'d' + index} className='row-right-border'>
                                <td className='msku-cell highlight-row-bg-grey'>
                                    {brand.BrandName}
                                </td>
                                <td className='msku-cell highlight-row-bg-grey'>
                                    { }
                                </td>
                                <td className='msku-cell highlight-row-bg-grey'>
                                    { }
                                </td>
                                <td className='msku-cell highlight-row-bg-grey'>
                                    { }
                                </td>
                                <td className='msku-cell highlight-row-bg-grey'>
                                    {brand.BrandName}
                                </td>
                            </tr>
                        </React.Fragment>
                    ))
                }
                {
                    props.data && (
                        <tr className="highlight-row-bg-orange row-right-border">
                            <td className='msku-cell'>
                                {props.data.Category.CategoryName}
                            </td>
                            <td className='msku-cell'>
                                { }
                            </td>
                            <td className='msku-cell'>
                                { }
                            </td>
                            <td className='msku-cell'>
                                { }
                            </td>
                            <td className='msku-cell'>
                                {props.data.Category.CategoryName} TOTAL
                            </td>
                        </tr>
                    )
                }
            </tbody>

        </table>
    );
})

export default MskuInfoTable;